import {injectable} from "inversify";
import {QueryOrderInterface} from "@/modules/vue/interfaces";
import {SelectQueryBuilder} from "typeorm";
import {OrderType} from "@/modules/vue/types";
import {CompetitionPlayerLog} from "@/modules/competitions/entity";

@injectable()
export class CompetitionPlayerLogQueryOrder implements QueryOrderInterface<CompetitionPlayerLog> {
  getDefaultField(): string {
    return 'log.goals';
  }

  getDefaultOrder(): OrderType {
    return 'DESC';
  }

  getOnlySingleOrder(): { [key: string]: OrderType } {
    return {
      'log.goals': 'DESC',
      'log.yellow': 'DESC',
      'log.yellowRed': 'DESC',
      'log.red': 'DESC',
      'log.matches': 'DESC',
    };
  }

  getFields(): { [key: string]: string } {
    return {
      'log.goals': translator.t('goals'),
      'log.red': translator.t('red'),
      'log.yellowRed': translator.t('yellow_red'),
      'log.yellow': translator.t('yellow'),
      'log.matches': translator.t('matches'),
    };
  }

  apply(query: SelectQueryBuilder<CompetitionPlayerLog>, field: string | null, order: OrderType | null): SelectQueryBuilder<CompetitionPlayerLog> {
    if (field === null) {
      field = this.getDefaultField();
    }

    if (order === null) {
      order = this.getDefaultOrder();
    }

    query.addOrderBy(field, order);

    if (field !== 'log.matches') {
      query.addOrderBy('log.matches', 'ASC')
    }

    return query;
  }
}